import React, { PureComponent } from 'react'
import { Grid, FormControl, InputLabel, Input } from '@material-ui/core'

import Select from 'react-select'

class NewRole extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      className: '',
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const selectElement = document.querySelector(`.select_permissions .Select-multi-value-wrapper`)

    if (selectElement) {
      if (selectElement.offsetHeight > 150 && prevState.className !== 'scroll_permissions') {
        this.setState({
          className: 'scroll_permissions',
        })
      } else if (selectElement.offsetHeight < 150 && prevState.className !== '') {
        this.setState({
          className: '',
        })
      }
    }
  }

  setRoleName = (event) => {
    const { value } = event.target
    this.props.setChange('name', value)
  }

  setRolePermissions = (permissions) => {
    let updatedPermissions = []
    // console.log(permissions, "permissions")
    const allPermission =
      permissions && permissions.findIndex((permission) => permission.value === 'All')

    if (allPermission === -1) {
      updatedPermissions =
        (permissions && permissions.length && permissions.map((permission) => permission.value)) ||
        []
    } else {
      updatedPermissions =
        (this.props.permissions &&
          this.props.permissions.length &&
          this.props.permissions
            .filter((perm) => perm.permission)
            .map((permission) => permission.key)) ||
        []
    }

    this.props.setChange('permissions', updatedPermissions)
  }

  render() {
    const { role = {}, permissions } = this.props

    const filteredPermissions =
      (permissions &&
        permissions.length &&
        permissions.filter((permission) => permission.permission)) ||
      []

    const permissionOptions =
      (filteredPermissions &&
        filteredPermissions.length &&
        filteredPermissions.map((permission) => ({
          ...permission,
          label: permission.permission,
          value: permission.key,
        }))) ||
      []

    let updatedPermissionOptions = [...permissionOptions]

    if (role.permissions.length !== filteredPermissions.length) {
      updatedPermissionOptions = [
        { label: 'Select All', value: 'All' },
        ...updatedPermissionOptions,
      ]
    }

    return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <FormControl fullWidth>
            <InputLabel htmlFor="input-with-icon-adornment">Please enter role name</InputLabel>
            <Input
              onChange={this.setRoleName}
              value={role.name || ''}
              id="input-with-icon-adornment"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} className="margin-top-small">
          <InputLabel htmlFor="input-with-icon-adornment">Permissions</InputLabel>
          <Select
            className={`select_permissions ${this.state.className}`}
            multi={true}
            value={role.permissions || []}
            fullWidth={true}
            onChange={this.setRolePermissions}
            options={updatedPermissionOptions}
            placeholder="Select Permissions"
          />
        </Grid>
      </Grid>
    )
  }
}

export default NewRole



// WEBPACK FOOTER //
// ./src/components/RolePermissions/NewRole.js